angular.module('google-pay', [])
    .service('GooglePay', GooglePay);

GooglePay.$inject = ['$state', 'configs', '$rootScope', '$timeout', 'PortalApi', 'Authentication', '$stateParams', 'uibDatepickerConfig', '$location', '$translate', 'Notification', 'Analytics', 'ClientCards', 'DateFormater', '$anchorScroll', 'Localization'];

function GooglePay($state, configs, $rootScope, $timeout, PortalApi, Authentication, $stateParams, uibDatepickerConfig, $location, $translate, Notification, Analytics, ClientCards, DateFormater, $anchorScroll, Localization) {

    var googlepay = {
        data: {

        },
    };

    return googlepay;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/google-pay/services/google-pay.js
 ** module id = 106
 ** module chunks = 1
 **/